module.exports = __webpack_public_path__ + "static/media/Gold-Mine.7fcfce19.png";